import { getSelectedFormIndexItem } from '../../selectors/get-selected-form-index-item';
import { setLastViewedForm } from '../utils';
export const setSelectedFormId = formId => async ({
  setState,
  getState
}, {
  projectId
}) => {
  var _getSelectedFormIndex;
  setState({
    selectedFormId: formId
  });
  const selectedProjectFormId = (_getSelectedFormIndex = getSelectedFormIndexItem(getState())) === null || _getSelectedFormIndex === void 0 ? void 0 : _getSelectedFormIndex.projectFormId;
  await setLastViewedForm(projectId, {
    templateFormId: selectedProjectFormId
  });
};